/**
 * Clinical Notification Task Facade
 *
 * Stable API surface for clinical notification operations. Kept separate from
 * the operational Task facade so notification and operational Task flows never
 * blur (D2/D3).
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Task } from "@medplum/fhirtypes";
import {
  createNotificationTask,
  markNotificationTaskRead,
  type CreateNotificationTaskInput,
  type MarkNotificationTaskReadInput,
} from "@benchmark/core/actions";

/**
 * Creates a clinical notification facade bound to a MedplumClient.
 * @agentic connections
 */
export function createNotificationTaskFacade(medplum: MedplumClient) {
  return {
    /**
     * Idempotently create an unread clinical notification.
     * @agentic connections
     */
    create: (input: CreateNotificationTaskInput): Promise<Task> =>
      createNotificationTask(medplum, input),

    /**
     * Mark a clinical notification as read.
     * @agentic connections
     */
    markRead: (input: MarkNotificationTaskReadInput): Promise<Task> =>
      markNotificationTaskRead(medplum, input),
  };
}
